<template>
  <div>
    <CodVerificationOnboarding v-if="shouldShowOnboarding" />
    <CODVerificationForm v-else />
  </div>
</template>

<script>
import CodVerificationOnboarding from "@/components/Automation/CodVerificationOnboarding";
import CODVerificationForm from "@/components/Automation/CODVerificationForm";

export default {
  components: {
    CodVerificationOnboarding,
    CODVerificationForm
  },
  computed: {
    shouldShowOnboarding() {
      const store = this.$store.getters.getStore;
      return store.isCODVerificationEnabled === false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
